import React from 'react';
import { FlaskConical, Dna, ShieldAlert } from 'lucide-react';
export function ScienceSection() {
  return <section className="bg-crema py-16 md:py-24 px-4" data-id="element-277">
      <div className="max-w-4xl mx-auto" data-id="element-278">
        <div className="text-center mb-12" data-id="element-279">
          <h2 className="text-[28px] md:text-[40px] font-playfair font-bold text-marron mb-4" data-id="element-280">
            🔬 LA VERDAD BIOLÓGICA QUE LO CAMBIA TODO
          </h2>
          <p className="text-xl text-carbon" data-id="element-281">
            Tu cuerpo no perdió la capacidad de producir colágeno.
          </p>
          <p className="text-2xl font-bold text-terracota mt-2" data-id="element-282">
            Solo perdió los materiales y las señales para fabricarlo.
          </p>
        </div>

        <div className="space-y-6 text-[16px] md:text-[18px] text-carbon mb-12 max-w-3xl mx-auto" data-id="element-283">
          <p data-id="element-284">
            Dentro de tu dermis, ahora mismo, existen células llamadas{' '}
            <strong data-id="element-285">fibroblastos</strong>. Son las obreras de tu piel. Su único
            trabajo es fabricar colágeno tipo I y III, elastina y ácido
            hialurónico. Trabajan sin descanso las 24 horas del día...
          </p>
          <p className="font-bold text-center text-xl" data-id="element-286">
            Si tienen lo que necesitan.
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-card overflow-hidden mb-12" data-id="element-287">
          <div className="overflow-x-auto" data-id="element-288">
            <table className="w-full text-left border-collapse" data-id="element-289">
              <thead data-id="element-290">
                <tr className="bg-verde text-white" data-id="element-291">
                  <th className="p-4 font-montserrat font-bold uppercase text-sm tracking-wider" data-id="element-292">
                    Aminoácido
                  </th>
                  <th className="p-4 font-montserrat font-bold uppercase text-sm tracking-wider" data-id="element-293">
                    Función
                  </th>
                  <th className="p-4 font-montserrat font-bold uppercase text-sm tracking-wider" data-id="element-294">
                    Fuente Natural
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-295">
                <tr className="hover:bg-gray-50 transition-colors" data-id="element-296">
                  <td className="p-4 font-bold text-marron flex items-center" data-id="element-297">
                    <Dna className="w-5 h-5 mr-2 text-terracota" data-id="element-298" /> Glicina
                  </td>
                  <td className="p-4 text-carbon" data-id="element-299">
                    Columna vertebral de la triple hélice
                  </td>
                  <td className="p-4 text-carbon" data-id="element-300">
                    Caldo de huesos, piel de pollo
                  </td>
                </tr>
                <tr className="hover:bg-gray-50 transition-colors" data-id="element-301">
                  <td className="p-4 font-bold text-marron flex items-center" data-id="element-302">
                    <FlaskConical className="w-5 h-5 mr-2 text-terracota" data-id="element-303" />{' '}
                    Prolina
                  </td>
                  <td className="p-4 text-carbon" data-id="element-304">
                    Estabilidad y resistencia de la fibra
                  </td>
                  <td className="p-4 text-carbon" data-id="element-305">
                    Claras de huevo, espárragos
                  </td>
                </tr>
                <tr className="hover:bg-gray-50 transition-colors" data-id="element-306">
                  <td className="p-4 font-bold text-marron flex items-center" data-id="element-307">
                    <ShieldAlert className="w-5 h-5 mr-2 text-terracota" data-id="element-308" />{' '}
                    Lisina
                  </td>
                  <td className="p-4 text-carbon" data-id="element-309">
                    Aminoácido esencial que el cuerpo NO fabrica
                  </td>
                  <td className="p-4 text-carbon" data-id="element-310">Legumbres, quinoa, atún</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="bg-rojo/5 p-4 text-center border-t border-rojo/10" data-id="element-311">
            <p className="font-bold text-rojo" data-id="element-312">
              Si falta uno solo, la fibra no se completa. La piel cede.
            </p>
          </div>
        </div>

        <div className="bg-marron text-white p-8 md:p-12 rounded-2xl shadow-xl relative overflow-hidden" data-id="element-313">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full transform translate-x-1/2 -translate-y-1/2" data-id="element-314"></div>

          <h3 className="text-2xl md:text-3xl font-playfair font-bold mb-6 text-terracota" data-id="element-315">
            El Tercer Enemigo: La Glicación
          </h3>
          <p className="text-lg md:text-xl leading-relaxed mb-6 font-inter font-light" data-id="element-316">
            Cada vez que comes azúcar o harinas refinadas, las moléculas de
            glucosa se pegan a tus fibras de colágeno existentes. Las endurecen.
            Las rompen. Es el mayor acelerador del envejecimiento dérmico que
            existe, y la industria de suplementos prefiere que nunca lo sepas
            porque si lo sabes, dejas de comprarles.
          </p>
          <blockquote className="border-l-4 border-verde pl-6 py-2 text-xl md:text-2xl font-playfair italic font-semibold" data-id="element-317">
            "Este triple mecanismo es la razón real por la que tu piel está
            cediendo. Y ningún suplemento en polvo ataca los tres
            simultáneamente. Hasta ahora."
          </blockquote>
        </div>
      </div>
    </section>;
}